import { BlogShared } from './../../general/shared/blog-shared';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-block-users',
  templateUrl: './edit-block-users.component.html',
  styleUrls: ['./edit-block-users.component.scss'],
})
export class EditBlockUsersComponent implements OnInit {
  blockedUsers: BlogUserModel[] = [];

  constructor(
    private blogService: BlogService,
    private snackBarService: SnackBarService,
    private blogShared: BlogShared
  ) {
    this.blogService.userBlockList().then((res) => {
      if (res.isSuccess()) {
        this.blockedUsers = res.getData().getBlogUsers();
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  ngOnInit() {}

  profile(username: string) {
    // this.blogShared.openProfile(username);
    this.blogService.goToUserProfile(username);
  }

  unBlock(user: BlogUserModel) {
    this.blogService.userBlock(user.id).then((res) => {
      if (res.isSuccess()) {
        this.blockedUsers.splice(this.blockedUsers.indexOf(user), 1);
      }
    });
  }
}
